// extracted by mini-css-extract-plugin
export default {"user__info":"User_user__info__VWo-z","icon-up":"User_icon-up__ehA9g","icon-down":"User_icon-down__RZS+v","user__avatar":"User_user__avatar__Ysc08"};